module.exports = __webpack_public_path__ + "img/Edificios.889e2c5b.svg";